import { ILocation, UserProfileRole } from 'lib/types/user';
import _ from 'lodash';
import { createContext, useContext } from 'react';

export interface ISelectPopulationModalContext {
  deselectedPreviewUserIds: number[];
  getIsSelected: (userId: number) => boolean;
  handleClose: () => void;
  handleDeselectAll: () => void;
  handleSelectAll: () => void;
  handleSubmit: () => void;
  handleTableRowClick: (userId: number) => void;
  handleTogglePreview: () => void;
  isPreview: boolean;
  isSelectAll: boolean;
  isSelectAllVisible: boolean;
  populationName?: string;
  selectedCount: number;
  selectedCustomCategoryValue: string;
  selectedDepartment: string;
  selectedLocations: {
    locations: ILocation[];
    exclude: boolean;
  };
  selectedRole: UserProfileRole;
  selectedEmployeeType: string;
  selectedUserIds: number[];
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
  setSelectedCustomCategoryValue: (customCategoryValue: string) => void;
  setSelectedDepartment: (department: string) => void;
  setSelectedEmployeeType: (employeeType: string) => void;
  setSelectedLocations: ({
    locations,
    exclude,
  }: {
    locations: ILocation[];
    exclude: boolean;
  }) => void;
  setSelectedRole: (role: UserProfileRole) => void;
}

export const SelectPopulationModalContext =
  createContext<ISelectPopulationModalContext>({
    deselectedPreviewUserIds: [],
    getIsSelected: () => false,
    handleClose: _.noop,
    handleDeselectAll: _.noop,
    handleSelectAll: _.noop,
    handleSubmit: _.noop,
    handleTableRowClick: _.noop,
    handleTogglePreview: _.noop,
    isPreview: false,
    isSelectAll: false,
    isSelectAllVisible: false,
    populationName: 'Team Members',
    selectedCount: 0,
    selectedCustomCategoryValue: undefined,
    selectedDepartment: undefined,
    selectedLocations: { locations: [], exclude: false },
    selectedEmployeeType: undefined,
    selectedRole: undefined,
    selectedUserIds: [],
    searchTerm: '',
    setSearchTerm: () => {},
    setSelectedCustomCategoryValue: _.noop,
    setSelectedDepartment: _.noop,
    setSelectedEmployeeType: _.noop,
    setSelectedLocations: _.noop,
    setSelectedRole: _.noop,
  });

/** Access the state of the current SelectPopulationModal instance. */
export const useSelectPopulationModalContext = () =>
  useContext(SelectPopulationModalContext);
